"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _vars = require("@devsta/ui-kit/dist/common/styles/vars"),
    _uiKit = require("@devsta/ui-kit"),
    _Caption = _interopRequireDefault(require("../../Caption"));

require("../styles/_srt-captions.scss");

var PLACEHOLDER = "SRT files contain caption information, they are a text based file delivered separately to your video and can be activated at will - Best for SEO/Multi-language videos.";

function onDeleteSrt(_ref) {
  var onUpdate = _ref.onUpdate;
  return function () {
    onUpdate();
  };
}

function renderPlaceHolder(isSmallView) {
  return isSmallView ? null : _react["default"].createElement("p", null, PLACEHOLDER);
}

function SrtCaptions(_ref2) {
  var requestedAddons = _ref2.requestedAddons,
      appliedAddons = _ref2.appliedAddons,
      addSrt = _ref2.addSrt,
      updateSrt = _ref2.updateSrt,
      disabled = _ref2.disabled,
      size = _ref2.size,
      showTitle = _ref2.showTitle,
      buttonText = _ref2.buttonText,
      SRT_CAPTIONS = requestedAddons.SRT_CAPTIONS,
      _appliedAddons$SRT_CA = appliedAddons.SRT_CAPTIONS,
      appliedSrtCaptions = void 0 === _appliedAddons$SRT_CA ? [] : _appliedAddons$SRT_CA,
      isSmallView = size.width < _vars.NUMERIC_MEDIA_SIZES.small;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      "srt-captions--large": isSmallView,
      "srt-captions": !isSmallView
    })
  }, showTitle && _react["default"].createElement("h3", {
    className: "srt-captions__label"
  }, "SRT CAPTIONS"), _react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      "srt-captions__content": !isSmallView
    })
  }, Array.isArray(SRT_CAPTIONS) && 0 < SRT_CAPTIONS.length ? SRT_CAPTIONS.map(function (language, index) {
    var onUpdate = updateSrt(index),
        selectedCaptions = SRT_CAPTIONS.filter(function (_ref3) {
      var value = _ref3.value;
      return !!value;
    }).map(function (_ref4) {
      var value = _ref4.value;
      return value;
    }),
        appliedCaptions = Array.isArray(appliedSrtCaptions) ? appliedSrtCaptions.filter(function (_ref5) {
      var value = _ref5.value;
      return !!value;
    }).map(function (_ref6) {
      var value = _ref6.value;
      return value;
    }) : [];
    return appliedCaptions.forEach(function (item) {
      selectedCaptions.includes(item) || selectedCaptions.push(item);
    }), _react["default"].createElement(_Caption["default"], {
      key: "".concat(language.value),
      defaultLanguage: language,
      label: "CAPTION ".concat("".concat(index + 1).padStart(2, "0")),
      onChange: onUpdate,
      onDelete: onDeleteSrt({
        onUpdate: onUpdate
      }),
      selectedCaptions: selectedCaptions,
      disabled: disabled,
      type: "SRT_CAPTIONS"
    });
  }) : renderPlaceHolder(isSmallView)), _react["default"].createElement(_uiKit.Button, {
    className: (0, _classnames["default"])({
      "srt-captions__button--large": isSmallView,
      "srt-captions__button": !isSmallView
    }),
    type: "PRIMARY",
    onClick: addSrt,
    disabled: disabled,
    small: !isSmallView
  }, buttonText));
}

var _default = (0, _react.memo)(SrtCaptions);

exports["default"] = _default;